// extracted by mini-css-extract-plugin
module.exports = {"content":"_02712f2b3b--content--lz86H","icon":"_02712f2b3b--icon--gHr55","heading":"_02712f2b3b--heading--UKbhW","footer":"_02712f2b3b--footer--ab3l2"};